import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router';
import  Header  from "../common/header";
import  Footer  from "../common/footer";
export default function AppLayout  ()  {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const storedUserData = sessionStorage.getItem('userData');
    if (storedUserData) {
      setUserData(JSON.parse(storedUserData));
    }
  }, []);

  return (
    <div className="App">
          <div className="container-fluid position-relative d-flex p-0">
            <div className="content">
              <Header />
              <div
                className="container-fluid pt-2 px-2 "
                style={{ marginbottom: "100px" }}
              >
        <Outlet />
        </div>
          </div>
          <Footer />
        </div>
      </div>
  );
};